import { PayloadAction } from '@reduxjs/toolkit'
import { ReduxAppState } from '../types'

export const resetMruView = (
  state: ReduxAppState,
  action: PayloadAction<undefined>
) => {
  delete state.views?.mruView
}
